class AddwinMotion {
  constructor() {
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.reveals = document.querySelectorAll('[data-addwin-reveal]');
    this.hero = document.querySelector('[data-addwin-hero]');
    this.init();
  }

  init() {
    if (this.reduceMotion) {
      this.reveals.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    this.reveals.forEach((element) => observer.observe(element));

    if (this.hero) {
      window.addEventListener('scroll', () => {
        const offset = Math.min(window.scrollY * 0.08, 48);
        this.hero.style.setProperty('--addwin-hero-shift', `${offset}px`);
      }, { passive: true });
    }

    document.querySelectorAll('[data-aw-parallax]').forEach((element) => {
      window.addEventListener('scroll', () => {
        const rect = element.getBoundingClientRect();
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        element.style.setProperty('--aw-parallax', `${Math.max(-8, Math.min(4, progress * 12 - 8))}%`);
      }, { passive: true });
    });
  }
}

class AddwinSlider {
  constructor(root) {
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('[data-aw-slide]'));
    this.dots = Array.from(root.querySelectorAll('[data-aw-dot]'));
    this.index = 0;
    this.delay = 6500;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelector('[data-aw-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    root.querySelector('[data-aw-next]')?.addEventListener('click', () => this.show(this.index + 1));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.awDot))));
    root.addEventListener('mouseenter', () => this.stop());
    root.addEventListener('mouseleave', () => this.start());
    this.show(0);
  }

  show(next) {
    this.index = (next + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.index));
    this.start();
  }

  start() {
    this.stop();
    if (this.reduceMotion) return;
    this.timer = window.setTimeout(() => this.show(this.index + 1), this.delay);
  }

  stop() {
    window.clearTimeout(this.timer);
  }
}

const initializeAddwin = () => {
  new AddwinMotion();
  document.querySelectorAll('[data-aw-slider]').forEach((slider) => {
    if (slider.dataset.awReady) return;
    slider.dataset.awReady = 'true';
    new AddwinSlider(slider);
  });
};

document.addEventListener('DOMContentLoaded', initializeAddwin, { once: true });
document.addEventListener('shopify:section:load', initializeAddwin);
